
export const cardType = (paymentMethod) => {
    const card = paymentMethod.type === "BANK_ACCOUNT" ? 'bank' : paymentMethod.cardType;
    switch (card?.toLowerCase()) {
        case 'bank': {
            return {
                icon: 'icon-network-bank-transfer',
                Name: 'Bank account'
            };
        }
        case 'visa' : {
            return {
                icon: 'icon-network-visa',
                Name: 'Visa'
            }
        }
        case 'master_card': {
            return {
                icon: 'icon-network-mastercard',
                Name: 'Mastercard'
            }
        }
        case 'amex': {
            return {
                icon: 'icon-bills-amex',
                Name: 'American Express'
            }
        }
        default: break;
    }
}
